import React from 'react'
import { fromJS } from 'immutable'
import type { BetType } from '@mobi/api-types/racePage/types'
import { layering } from '@mobi/component-library/Foundations'
import {
  MysteryBetContainerStyled,
  MysteryHeadingStyled,
} from '@core/Areas/MysteryBet/Components/Common/Common.styles'
import { SetBetError, SetSelectedQuickPick, state$ } from '@core/Areas/MysteryBet/driver'
import { MysteryQuickPicks } from '@core/Areas/Racing/Components/Mystery/Components/MysteryQuickPick'
import { MysteryQuickPickOptions } from '@core/Areas/Racing/Components/Mystery/MysteryTypes'
import { createMysterySelection } from '@core/Areas/Racing/Components/Mystery/utils'
import { BettingDrawer } from '@core/Components/BettingDrawer'
import { NoticeBox } from '@core/Components/NoticeBox'
import { createRaceObjectFromResponse } from '@core/Data/Racing'
import { useObservableImmutable } from '@core/Utils/hooks'
import { NumberOfBets } from '../Common/NumberOfBets'
import { ReviewMysteryDetails } from '../Common/ReviewMysteryDetails'

export const QuickPick: React.FC = () => {
  const [isDetailsOpen, setIsDetailsOpen] = React.useState(false)
  const mysteryData = useObservableImmutable(state$, ['currentData']).currentData?.toJS()
  const selectedQuickPick = useObservableImmutable(state$, ['selectedQuickPick']).selectedQuickPick
  const selectedBetCount = useObservableImmutable(state$, [
    'selectedQuickPickBetCount',
  ]).selectedQuickPickBetCount
  const isRaceClosed = useObservableImmutable(state$, ['isRaceClosed']).isRaceClosed
  const hasAnyDisabledOptions = !!mysteryData?.DisabledQuickPickOptions?.length
  const shouldBettingDrawerBeOpen = !isRaceClosed && !!selectedQuickPick && !!selectedBetCount

  const selectedMysteryOption = MysteryQuickPickOptions.find(x => x.uniqueKey === selectedQuickPick)
  const selectedDisplayPrice = selectedMysteryOption?.displayPrice
  const mysterySelection =
    selectedMysteryOption && mysteryData
      ? createMysterySelection({
          betType: 'mystery-quick-pick',
          betTypeName: selectedMysteryOption.uniqueKey,
          investmentWin: selectedMysteryOption.investment,
          investmentPlace: 0,
          isAlways: selectedMysteryOption.isAlways,
          mysteryOption: selectedMysteryOption.mysteryOption,
          mysteryType: selectedMysteryOption.mysteryType,
          productCode: selectedMysteryOption.productCode,
          raceInformation: fromJS(createRaceObjectFromResponse(mysteryData.Meeting)),
        })
      : undefined

  const shouldRenderReviewDetails =
    isDetailsOpen &&
    mysteryData &&
    mysterySelection &&
    selectedMysteryOption &&
    selectedDisplayPrice

  return (
    <MysteryBetContainerStyled>
      <MysteryHeadingStyled>Bet Type</MysteryHeadingStyled>
      <MysteryQuickPicks
        selectedKey={isRaceClosed ? null : selectedQuickPick}
        disabledQuickPicks={
          isRaceClosed
            ? MysteryQuickPickOptions.map(x => x.uniqueKey)
            : mysteryData?.DisabledQuickPickOptions
        }
        optionsPerRow={2}
        selectionCallback={SetSelectedQuickPick}
      />
      {hasAnyDisabledOptions && (
        <NoticeBox
          title='Not all mystery options are available for this race.'
          noticeBoxType='Info'
          hasBorder
        />
      )}
      <br />
      <NumberOfBets isDisabled={isRaceClosed || !selectedQuickPick} type='QuickPick' />

      <BettingDrawer
        shouldDisplayAboveTabNav
        forcedZIndex={layering.pageLayer}
        open={shouldBettingDrawerBeOpen && !shouldRenderReviewDetails}
        dataTId='mystery-buttons'
        handleQuickbetClick={() => {
          SetBetError(null)
          if (selectedDisplayPrice && mysterySelection) setIsDetailsOpen(true)
        }}
      />

      {shouldRenderReviewDetails && (
        <ReviewMysteryDetails
          open={isDetailsOpen}
          mysteryData={mysteryData}
          betType={selectedMysteryOption.productCode as BetType}
          optionNumber={selectedMysteryOption.mysteryOption}
          winStake={selectedDisplayPrice}
          placeStake={0}
          investmentWin={selectedMysteryOption.investment}
          numberOfBets={selectedBetCount || 1}
          isRaceClosed={isRaceClosed}
          onClosed={() => setIsDetailsOpen(false)}
        />
      )}
    </MysteryBetContainerStyled>
  )
}
